import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { AuthenticateGuard } from "@/components/AuthenticateGuard/AuthenticateGuard.tsx";
import { Layout } from "@/components/Layouts";
import { getSidebarItems } from "@/components/Layouts/Layout/sidebar";
import { type NotificationReadDto } from "@/config/apiClient/api.ts";
import { useGetCurrentTasksByPhase, useNotifications } from "@/hooks";
import { useRolePermission } from "@/hooks/rolePermission/useRolePermission";

export const AppRouteLayout = () => {
  const { t } = useTranslate();
  const { data: currentTasksData } = useGetCurrentTasksByPhase({});

  const totalTasksCount = currentTasksData?.data?.total || 0;

  const { useGetLatestNotificationsByGroups } = useNotifications();
  const { data: notificationsData } = useGetLatestNotificationsByGroups({
    page: 1,
    size: 10,
    receivedAt: undefined,
  });

  const { userHasPermission, hasBrokerKazaarRole } = useRolePermission();

  // Display all new notifications (not sent by the current user)
  const newNotifications: NotificationReadDto[] | undefined = useMemo(
    () =>
      notificationsData?.data?.data?.filter((notification) => {
        const authorParticipant = notification?.content?.participants?.find(
          (participant) => participant.isAuthor
        );
        return (
          authorParticipant?.id !== notification.recipient &&
          notification.receivedAt === null
        );
      }),
    [notificationsData]
  );

  const sideBarItems = getSidebarItems({
    t,
    hasBrokerKazaarRole,
    notificationCount: newNotifications?.length,
    taskCount: totalTasksCount,
    userHasPermission,
  }).filter((e) => e.visible);

  return (
    <AuthenticateGuard>
      <Layout sideBarItems={sideBarItems}>
        <Outlet />
      </Layout>
    </AuthenticateGuard>
  );
};
